<script setup>
import BaseButtonUploadReceipt from '@/components/ui/BaseButtonUploadReceipt.vue';
import { useSettingsStore } from '@/stores/storeSettings';  
import { trackAdriver } from '@/utils/metrika';

const storeSettings = useSettingsStore();

const props = defineProps({
    activeBtn: {
        type: Boolean,
        default: false
    },
    typeBtn: {
        type: String,
        default: ''
    }
})
</script>
<template>
    <div class="profile-empty">
        <p><slot></slot></p>
        <BaseButtonUploadReceipt :type-btn="props.typeBtn" @click="trackAdriver('upload-receipt-lc')" v-if="props.activeBtn && !storeSettings.isTelegramPage" class="profile-empty__btn btn --blue">Загрузить чек</BaseButtonUploadReceipt>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.profile-empty {
	display: flex;
	flex-direction: column;
	align-items: start;
    gap: 20px;
	p {
		font-weight: 500;
        font-size: 2rem;
        line-height: 120%;
        color: var(--text-inverse-100);
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
		}
	}
    &__btn {

        @media (max-width: vars.$x480) {
            width: 100%;
        }
    }
}
</style>